import { useEffect, useMemo } from "react";

import { useAppDispatch, useAppSelector } from "stores";

import { dialogSlice } from "./reducers";

// Register dialog name here
export type DialogFieldName = "ExportDialog";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDialog = <T = any>({
  name,
  key = "id", // Key to defined data is detail or not
  onShowChange,
}: {
  name: DialogFieldName;
  key?: string;
  onShowChange?: (show?: boolean, data?: T) => void;
}) => {
  const dispatch = useAppDispatch();
  const dialog = useAppSelector((state) => state?.dialog?.[name]) || {};
  const isDetail = useMemo(
    () => Boolean(dialog?.data?.[key || ""]),
    [dialog?.data, key]
  );

  const onToggle = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: { showSuccess?: boolean; showSuccessImport?: boolean } & any
  ) => {
    dispatch(dialogSlice.actions.onToggle({ name, data: data || {} }));
  };

  const reset = () => {
    dispatch(dialogSlice.actions.reset(name));
  };

  useEffect(() => {
    if (typeof onShowChange === "function")
      onShowChange(dialog.show, dialog.data as T);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialog.show]);

  return {
    dialog: dialog as {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      data: T & { callback: (e?: any) => void };
      show: boolean;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: dialog?.data as T & { callback: (e?: any) => void },
    show: dialog.show,
    isDetail,
    onToggle,
    reset,
    callback: (dialog?.data?.callback as (e?: unknown) => void) || (() => {}),
  };
};
